/* Everything the whole portal shares: the taxonomy and the server's settings.
   ------------------------------------------------------------------------
   CONTRACT — owned by the foundation. See PLAN.md.
   ------------------------------------------------------------------------ */

import { createContext, useContext } from "react";
import type { Settings, Taxonomy } from "./types";

export interface Portal {
  taxonomy: Taxonomy | null;
  settings: Settings | null;
}

export const PortalContext = createContext<Portal>({ taxonomy: null, settings: null });

export function usePortal(): Portal { return useContext(PortalContext); }

/* A feature nobody has answered for yet is off. The portal renders with the
   generator and the file maker simply absent rather than guessing they are on:
   guessing wrong here spends money. */
export function useFeature(id: string): boolean {
  const { settings } = usePortal();
  return settings?.features?.[id] === true;
}
